import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { toast } from '../../../services/toastService';
import { equipmentCertificateService } from '../../../services/equipmentCertificateService';
import { equipmentCertificateSchema } from '../../../validations/equipmentCertificateSchema';

const EquipmentCertificateForm = ({getAsync,id,setId}) => {

  const isEditMode= Boolean(id);
  const initialForm = {
    certificateNo: "",
    stickerNo: "",
    equipmentDescription: "",
    equipmentSerialIdNo: "",
    equipmentType: "",
    inspectionDate: "",
    expiryDate: "",
    companyName: "",
    plateNo: "",
    manufacturer: "",
    inspectedBy: "",
    capacitySWL: "",
    remarks: "",
    type:"",
  };

   const {
     register,
     handleSubmit,
     reset,
     formState: { errors, isSubmitting },
   } = useForm({
     resolver: yupResolver(equipmentCertificateSchema),
     defaultValues: initialForm,
   });
  useEffect(() => {
      if(id>0) {
        editAsync();
      }
    }, [id]);
    const editAsync = async () => {
      try {
        const result = await equipmentCertificateService.edit(id);
        if (!result.isSuccess) {
          toast.error(result.errors[0] || "Failed to edit Id Card");
          return;
        }
        // Fill form data
      reset({
        certificateNo: result.value.certificateNo,
        stickerNo: result.value.stickerNo,
        equipmentDescription: result.value.equipmentDescription,
        equipmentSerialIdNo: result.value.equipmentSerialIdNo,
        equipmentType: result.value.equipmentType,
        inspectionDate: result.value.inspectionDate?.split("T")[0],
        expiryDate: result.value.expiryDate?.split("T")[0],
        companyName: result.value.companyName,
        plateNo: result.value.plateNo,
        manufacturer: result.value.manufacturer,
        inspectedBy: result.value.inspectedBy,
        capacitySWL: result.value.capacitySWL,
        remarks: result.value.remarks,
        type:"",
      });
      } catch (error) {
        toast.error("An error occurred while updating the Id Card");
        console.log(error);
      }
    };
    const onSubmit = async (data) => {
    if(isEditMode) await updateAsync(data); 
    else await addAsync(data);
    };
    const addAsync=async (data)=>{
   try {
    console.log("SUBMIT DATA:", data);
      const result = await equipmentCertificateService.create(data);
      if(!result.isSuccess) {
        toast.error(result.errors[0] || "Failed to create Id Card");
        return;
      }
      console.log(result);
      toast.success("Record added successfully");
      handleClear();
      await getAsync();
    } catch (error) {
       toast.error("An error occurred while creating the Id Card");
     console.log(error.response.data.errors);
    }
    }
    const updateAsync=async (data)=>{
      try {
      const result = await equipmentCertificateService.update(id,data);
      if(!result.isSuccess) {
        toast.error(result.errors[0] || "Failed to create Id Card");
        return;
      }
      console.log(result);
      toast.success("Record updated successfully");
      handleClear();
      getAsync();
    } catch (error) {
       toast.error("An error occurred while creating the Id Card");
      console.log(error);
    }
    }
    const handleClear=()=>{
      setId(0);
      reset(initialForm);
    }
   return (
     <section className="section-id-card-form">
       <form onSubmit={handleSubmit(onSubmit)}>
         <div className="row">
           <div className="col-md-6">
             <div className="form-group">
               <label>Certificate No.</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Certificate No."
                 {...register("certificateNo")}
               />
               <small className="text-danger">
                 {errors.certificateNo?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Equipment Description</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Equipment Description"
                 {...register("equipmentDescription")}
               />
               <small className="text-danger">
                 {errors.equipmentDescription?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Sticker No.</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Sticker No."
                 {...register("stickerNo")}
               />
               <small className="text-danger">
                 {errors.stickerNo?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Serial No.</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Serial No."
                 {...register("equipmentSerialIdNo")}
               />
               <small className="text-danger">
                 {errors.equipmentSerialIdNo?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Id / Plate No.</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Id / Plate No."
                 {...register("plateNo")}
               />
               <small className="text-danger">{errors.plateNo?.message}</small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Capacity / SWL</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Capacity / SWL"
                 {...register("capacitySWL")}
               />
               <small className="text-danger">
                 {errors.capacitySWL?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Inspection Date</label>
               <input
                 type="date"
                 className="form-control"
                 {...register("inspectionDate")}
               />
               <small className="text-danger">
                 {errors.inspectionDate?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Expiry Date</label>
               <input
                 type="date"
                 className="form-control"
                 {...register("expiryDate")}
               />
               <small className="text-danger">
                 {errors.expiryDate?.message}
               </small>
             </div>
           </div>

            <div className="col-md-6">
             <div className="form-group">
               <label>Make</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Make"
                 {...register("manufacturer")}
               />
               <small className="text-danger">
                 {errors.manufacturer?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Equipment Type</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Equipment Type"
                 {...register("equipmentType")}
               />
               <small className="text-danger">
                 {errors.equipmentType?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Company Name</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Company Name"
                 {...register("companyName")}
               />
               <small className="text-danger">
                 {errors.companyName?.message}
               </small>
             </div>
           </div>

          

           <div className="col-md-6">
             <div className="form-group">
               <label>Inspected By</label>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Enter Inspector Name"
                 {...register("inspectedBy")}
               />
               <small className="text-danger">
                 {errors.inspectedBy?.message}
               </small>
             </div>
           </div>

           <div className="col-md-6">
             <div className="form-group">
               <label>Type</label>
               <select className="form-control" {...register("type")}>
                 <option value="">Select Type</option>
                 {!isEditMode && <option value={0}>New</option>}
                 {isEditMode && <option value={1}>Renew</option>}
                 {isEditMode && <option value={2}>Update</option>}
               </select>
               <small className="text-danger">{errors.type?.message}</small>
             </div>
           </div>
           <div className="col-12">
             <div className="form-group">
               <label>Remarks</label>
               <textarea
                 className="form-control"
                 rows="4"
                 placeholder="Enter Remarks"
                 {...register("remarks")}
               ></textarea>
             </div>
           </div>

           <div className="col-12">
             <div className="form-group flex-end">
               <button
                 type="submit"
                 className="my-button"
                 disabled={isSubmitting}
               >
                 {isSubmitting ? "Saving..." : "Save"}
               </button>
             </div>
           </div>
         </div>
       </form>
     </section>
   );
}

export default EquipmentCertificateForm